import { RightSizingRecommendation } from "../../../../../services/cloudchipr.api";
import { RootState } from "../../../../store";
import { rightsizingRecommendationsSelector } from "../rightsizingRecommendationsSelector";

export const rightsizingRecommendationsDataSelector = (
  state: RootState,
): RightSizingRecommendation[] | undefined => {
  return rightsizingRecommendationsSelector(state)?.data;
};
